import { createLockedCalendarEventsStore, EventsCacheLockId } from 'owa-calendar-events-store';

export function getUpNextCacheLockId(scenario: string): EventsCacheLockId {
    const lockedCalendarEventsStore = createLockedCalendarEventsStore(scenario + '_UpNext');
    return lockedCalendarEventsStore.getLockId();
}
